import { Component } from '@theme/component';
import { Wishlist } from '@theme/wishlist';

/**
 * A heart-shaped toggle button that adds/removes a product from the wishlist.
 * Works standalone (no login required) — state lives in localStorage.
 *
 * @typedef {object} Refs
 * @property {HTMLButtonElement} button - The toggle button.
 *
 * @extends {Component<Refs>}
 */
class WishlistButton extends Component {
  requiredRefs = ['button'];

  get productId() {
    return this.dataset.productId;
  }

  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(Wishlist.EVENT_NAME, this.onWishlistUpdate);
    this.refs.button.addEventListener('click', this.onClick);
    this.render();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(Wishlist.EVENT_NAME, this.onWishlistUpdate);
  }

  onWishlistUpdate = () => {
    this.render();
  };

  onClick = (/** @type {MouseEvent} */ event) => {
    event.preventDefault();
    event.stopPropagation();

    if (!this.productId) return;

    const isActive = Wishlist.toggle(this.productId);
    this.classList.toggle('wishlist-button--active', isActive);
    this.refs.button.setAttribute('aria-pressed', String(isActive));
  };

  render() {
    if (!this.productId) return;
    const isActive = Wishlist.has(this.productId);
    this.classList.toggle('wishlist-button--active', isActive);
    this.refs.button.setAttribute('aria-pressed', String(isActive));
  }
}

if (!customElements.get('wishlist-button')) {
  customElements.define('wishlist-button', WishlistButton);
}
